import api from '../utils/axios';

export interface AppServiceInfo {
  name: string;
  service: string;
  state: string;
  status: string;
  health: string;
  ports: unknown;
}

export interface AppLifecycleStatus {
  status: string;
  services: AppServiceInfo[];
  has_compose: boolean;
  app_url: string | null;
  in_progress?: boolean;
  error?: string;
}

export interface AppLifecycleActionResponse {
  status: string;
  message: string;
}

export const appLifecycleApi = {
  async getStatus(projectId: string): Promise<AppLifecycleStatus> {
    const response = await api.get(
      `/dev-agent/projects/${projectId}/app-lifecycle/status`,
    );
    return response.data;
  },

  async startApp(projectId: string): Promise<AppLifecycleActionResponse> {
    const response = await api.post(
      `/dev-agent/projects/${projectId}/app-lifecycle/start`,
    );
    return response.data;
  },

  async stopApp(projectId: string): Promise<AppLifecycleActionResponse> {
    const response = await api.post(
      `/dev-agent/projects/${projectId}/app-lifecycle/stop`,
    );
    return response.data;
  },
};
